
export class UserJobHistoryListRequest {
    public sessionToken!: string;
    public resultSize: number = 0;
    public resultPage: number = 0;
}
